import { OperatorMessageStatus } from './operator-message-status';

const FAILED_MESSAGE_STATUSES = new Set([OperatorMessageStatus.failed, OperatorMessageStatus.undelivered]);
export const operatorMessageStatusIsFailed = (status: OperatorMessageStatus): boolean =>
  FAILED_MESSAGE_STATUSES.has(status);
